import * as _ from "lodash";

const getTallestColumn = (chart) => {
    return _.maxBy(chart.hoverPoints, (point: any) => point.y);
};

export function tooltipPositioner(width, height, point) {
    const topPoint = getTallestColumn(this.chart);
    const { top } = topPoint.graphic.element.getBoundingClientRect();
    const leftColumn = this.chart.hoverPoints[0];
    const leftColumnElement = leftColumn.graphic.element;
    const tooltipDimension = {
        xGap: 250,
        yGap: 20,
        height: height,
        width: width,
    };

    const hasTooltipBreachedChartBoundaryWidth = point.plotX + width > this.chart.plotWidth;
    const hasTooltipBreachedChartBoundaryHeight = point.plotY + height < this.chart.plotHeight;

    if (hasTooltipBreachedChartBoundaryWidth) {
        tooltipDimension.xGap += width;
    }

    if (hasTooltipBreachedChartBoundaryHeight) {
        tooltipDimension.yGap += point.plotY;
    }

    return {
        x: leftColumnElement.getBoundingClientRect().left - tooltipDimension.xGap,
        y: top - (tooltipDimension.height + tooltipDimension.yGap),
    };
}

export function trafficAndEngagementTooltipPositioner(width, height, point) {
    const leftColumn = this.chart.hoverPoints[0];
    const leftColumnElement = leftColumn.graphic.element;
    const tooltipDimension = {
        xGap: 150,
        yGap: 350,
        height: height,
        width: width,
    };

    const hasTooltipBreachedChartBoundaryWidth = point.plotX + width > this.chart.plotWidth;

    if (hasTooltipBreachedChartBoundaryWidth) {
        tooltipDimension.xGap += width;
    }

    return {
        x: leftColumnElement.getBoundingClientRect().left - tooltipDimension.xGap,
        y: point.plotY - tooltipDimension.yGap,
    };
}
